module.exports = __webpack_public_path__ + "static/media/CosAssessmentsApp.e6e9443d.png";